// Needs to have the same name as the Feature enum in CLB!

export enum FeatureSwitch {
  FEATURE_FOR_UNIT_TESTS = 'FEATURE_FOR_UNIT_TESTS',
  PPA_12930_RECOMMENDED_PRICE_WITH_MIETSPIEGEL = 'PPA_12930_RECOMMENDED_PRICE_WITH_MIETSPIEGEL',
}

export const FeatureSwitchesDefaultValues: FeatureSwitchMap = {
  [FeatureSwitch.FEATURE_FOR_UNIT_TESTS]: true,
  [FeatureSwitch.PPA_12930_RECOMMENDED_PRICE_WITH_MIETSPIEGEL]: false,
}

export const ALL_FEATURES_ENABLED: FeatureSwitchMap = {
  [FeatureSwitch.FEATURE_FOR_UNIT_TESTS]: true,
  [FeatureSwitch.PPA_12930_RECOMMENDED_PRICE_WITH_MIETSPIEGEL]: true,
}

export type FeatureSwitchMap = Partial<Record<FeatureSwitch, boolean>>
